import React from "react";
import {
  dateWithAsterisk,
  formattedDateLong,
  FormattedDateWithAsterisk,
} from "../utils";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import ReactTooltip from "react-tooltip";

type Props = {
  date: string;
  updated?: boolean;
  unique_id?: string;
};

const TableReportDateWithFormat = ({
  date,
  updated = false,
  unique_id,
}: Props) => {
  return (
    <>
      {dateWithAsterisk(new Date(date), updated, "longUTC")}
      <span
        data-tip={`Local Time: ${formattedDateLong(date)}`}
        data-tooltip-id={
          unique_id ? `date-with-format-${unique_id}` : undefined
        }
        className="cursor-pointer"
      >
        <InformationCircleIcon className="h-4 w-4 text-gray-500 inline-block" />
      </span>
      <ReactTooltip
        html={true}
        className="hover:visible:opacity-1 p-2"
        delayHide={10}
        effect="solid"
        id={unique_id ? `date-with-format-${unique_id}` : undefined}
      />
    </>
  );
};

export const TableReportDateWithFormatAndClass = ({
  date,
  updated = false,
  unique_id,
  className,
}: {
  date: string;
  updated?: boolean;
  unique_id?: string;
  className?: string;
}) => {
  return (
    <>
      <div className={className}>
        <FormattedDateWithAsterisk
          date={date}
          updated={updated}
          dateFormatType="longUTC"
          isUnderlined={className === "underline"}
        />
      </div>
      <span
        data-tip={`Local Time: ${formattedDateLong(date)}`}
        data-tooltip-id={
          unique_id ? `date-with-format-${unique_id}` : undefined
        }
        className="cursor-pointer"
      >
        <InformationCircleIcon className="h-4 w-4 text-gray-500 inline-block" />
      </span>
      <ReactTooltip
        html={true}
        className="hover:visible:opacity-1 p-2"
        delayHide={10}
        effect="solid"
        id={unique_id ? `date-with-format-${unique_id}` : undefined}
      />
    </>
  );
};

export default TableReportDateWithFormat;
